export const RESPONSE_TIMEOUT = 10000; // 10 seconds timeout for responses
